import { Box, Typography, Paper } from "@mui/material";

import "./MyPerformance.scss";
import Loader from "../Loader";

import MyPerformanceHeader from "./MyPerformanceHeader";
import DashboardRenderer from "./Dashboard/DashboardRenderer";
import MyPerformanceWelcomeBanner from "./MyPerformanceWelcomeBanner";
import SalesRepMyPerformanceView from "./views/SalesRepMyPerformanceView";
import { useMyPerformanceController } from "./useMyPerformanceController";
import { SWITCH_OPTIONS, TYVASO_DPI_WIDGET_TYPES } from "./Dashboard/layouts";
import { isTyvasoProductSelection } from "./myPerformanceHelpers";

function MyPerformance({ isActive = true }) {
  const {
    showLoader,
    widgetProps,
    headerProps,
    isLeadership,
    firstName,
    displayIdentityLoading,
    roleKey,
    effectiveSelectedProduct,
    onExploreHcpClick,
  } = useMyPerformanceController({ isActive });
  const rbdSwitchOptions =
    roleKey === "RBD"
      ? [
        ...SWITCH_OPTIONS.RBD,
        ...(isTyvasoProductSelection(effectiveSelectedProduct)
          ? TYVASO_DPI_WIDGET_TYPES
          : []),
      ]
      : null;

  return (
    <>
      {showLoader && <Loader />}
      <Box
        sx={{
          position: "sticky",
          top: "142px",
          backgroundColor: "#f9fdff",
          zIndex: 9,
          width: "100%",
          maxWidth: "1360px",
          m: "0 auto",
        }}
      >
        <MyPerformanceHeader {...headerProps} />
      </Box>
      <Paper elevation={3} className="drawer-paper-performance">
        <Box
          sx={{
            p: 2,
            width: "100%",
            maxWidth: "1360px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {roleKey === "SALESREP" ? (
            <SalesRepMyPerformanceView
              summaryProps={widgetProps.salesRepPerformanceSummary}
              widgetProps={widgetProps}
              selectedProduct={effectiveSelectedProduct}
            />
          ) : (
            <>
              {!isLeadership && (
                <MyPerformanceWelcomeBanner
                  firstName={firstName}
                  nameLoading={displayIdentityLoading}
                  onExploreHcpClick={onExploreHcpClick}
                />
              )}
              <DashboardRenderer
                roleKey={roleKey}
                widgetProps={widgetProps}
                switchOptionsOverride={rbdSwitchOptions}
              />
            </>
          )}
          <Typography
            variant="caption"
            className="ai-generated-text"
            sx={{
              display: "block",
              color: "#718096",
              mt: 2,
              textAlign: "center",
            }}
          >
            The numbers shown here are for reference only. For the official
            metrics that drive Incentive Compensation, please check MainSail.
          </Typography>
        </Box>
      </Paper>
    </>
  );
}

export default MyPerformance;
